let pageNumber = 1;

export const getPageNumber = () => pageNumber;

export const increasePageNumber = () => {
  return ++pageNumber;
};

export const setPageNumber = (number: number) => {
  pageNumber = number;
};
